/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_InboxInputs */

const en_go_inbox = /** @type {(inputs: Go_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to the inbox`)
};

const de_go_inbox = /** @type {(inputs: Go_InboxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Posteingang`)
};

/**
* | output |
* | --- |
* | "Go to the inbox" |
*
* @param {Go_InboxInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const go_inbox = /** @type {((inputs?: Go_InboxInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_InboxInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_go_inbox(inputs)
	return en_go_inbox(inputs)
});